import { render, staticRenderFns } from "./role-edit.vue?vue&type=template&id=4ca96ba1"
import script from "./role-edit.vue?vue&type=script&lang=js"
export * from "./role-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca96ba1')) {
      api.createRecord('4ca96ba1', component.options)
    } else {
      api.reload('4ca96ba1', component.options)
    }
    module.hot.accept("./role-edit.vue?vue&type=template&id=4ca96ba1", function () {
      api.rerender('4ca96ba1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/account-management/role-management/role-edit.vue"
export default component.exports